import type { ComponentProps } from 'react'
import IdentityPreview from '../../shared/IdentityPreview'

type IdentityPreviewProps = ComponentProps<typeof IdentityPreview>

/**
 * Step 5: Identity Preview
 * Wrapper for shared IdentityPreview component
 */
export default function Step5_IdentityPreview(props: IdentityPreviewProps) {
  return <IdentityPreview {...props} />
}
